export enum OpportunitySearchBarView {
   LandingView,
   SecondViewFUll,
}

export interface IOpportunitySearchBarView {
   view?: OpportunitySearchBarView;
}
